import React from 'react';

const FlagSo = props => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 81 54" {...props}>
    <path fill="#4189DD" d="M0 0h81v54H0z" />
    <g transform="matrix(13 0 0 13 40.5 27)">
      <g id="seea529c4">
        <path id="s529b48d0" fill="#FFF" transform="rotate(18 3.157 -.5)" d="M0 0v1h.5z" />
        <use xlinkHref="#s529b48d0" transform="scale(-1 1)" />
      </g>
      <use xlinkHref="#seea529c4" transform="rotate(72)" />
      <use xlinkHref="#seea529c4" transform="rotate(-72)" />
      <use xlinkHref="#seea529c4" transform="rotate(144)" />
      <use xlinkHref="#seea529c4" transform="rotate(-144)" />
    </g>
  </svg>
);

export default FlagSo;
